// src/pages/CreateEducationContentPage/components/organisms/OrganismsContentPopup.jsx
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { updateEduTimetableOnServer } from "../../../../utils/indexedDB";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { Sub2 } from "../../../../assets/styles/Typography";
import { palette } from "../../../../assets/styles/Palette";

export default function MoleculeContentPopup({
  onClose,
  contentList = [],
  selectedTab = "전학년",
  lotationDetail = null,
  onLotationUpdate = null,
}) {
  // 콘텐츠 관리 상태들
  const [availableContents, setAvailableContents] = useState([]); // 사용 가능한 콘텐츠
  const [scheduledContents, setScheduledContents] = useState([]); // 편성된 콘텐츠
  const [selectedAvailable, setSelectedAvailable] = useState([]); // 왼쪽에서 선택된 항목들
  const [selectedScheduled, setSelectedScheduled] = useState([]); // 오른쪽에서 선택된 항목들

  // 컴포넌트 초기화 시 lotationDetail을 기반으로 콘텐츠 분류
  useEffect(() => {
    try {
      let currentScheduledContents = [];

      if (lotationDetail) {
        // 현재 탭에 해당하는 편성된 콘텐츠 가져오기
        if (selectedTab === "전학년") {
          currentScheduledContents = lotationDetail.gradeAll || [];
        } else if (selectedTab === "1학년") {
          currentScheduledContents = lotationDetail.grade1 || [];
        } else if (selectedTab === "2학년") {
          currentScheduledContents = lotationDetail.grade2 || [];
        } else if (selectedTab === "3학년") {
          currentScheduledContents = lotationDetail.grade3 || [];
        }
      }

      // 편성된 콘텐츠의 ID들을 Set으로 만들어서 빠른 검색 가능하게 함
      const scheduledContentIds = new Set(
        currentScheduledContents.map((content) => content._id)
      );

      // contentList를 편성된 것과 사용 가능한 것으로 분류
      const available = contentList.filter(
        (content) => !scheduledContentIds.has(content._id)
      );

      setAvailableContents(available);
      setScheduledContents(currentScheduledContents);

      console.log("초기화 완료 (lotationDetail 기반):", {
        selectedTab,
        available: available.length,
        scheduled: currentScheduledContents.length,
        lotationDetail: !!lotationDetail,
      });
    } catch (error) {
      console.error("콘텐츠 초기화 중 오류:", error);
      // 오류 시 기본값으로 설정
      setAvailableContents(contentList);
      setScheduledContents([]);
    }
  }, [contentList, selectedTab, lotationDetail]);

  // 오른쪽으로 이동 (편성하기)
  const moveToScheduled = () => {
    const itemsToMove = availableContents.filter((_, index) =>
      selectedAvailable.includes(index)
    );
    setScheduledContents((prev) => [...prev, ...itemsToMove]);
    setAvailableContents((prev) =>
      prev.filter((_, index) => !selectedAvailable.includes(index))
    );
    setSelectedAvailable([]);
  };

  // 왼쪽으로 이동 (편성 해제)
  const moveToAvailable = () => {
    const itemsToMove = scheduledContents.filter((_, index) =>
      selectedScheduled.includes(index)
    );
    setAvailableContents((prev) => [...prev, ...itemsToMove]);
    setScheduledContents((prev) =>
      prev.filter((_, index) => !selectedScheduled.includes(index))
    );
    setSelectedScheduled([]);
  };

  // 항목 선택 핸들러
  const handleAvailableSelect = (index) => {
    setSelectedAvailable((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleScheduledSelect = (index) => {
    setSelectedScheduled((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };

  const handleConfirm = async () => {
    try {
      console.log("Scheduled Contents:", scheduledContents);

      if (!lotationDetail) {
        console.error("Lotation detail not available");
        return;
      }

      console.log("Using existing Lotation Detail:", lotationDetail);

      // 기존 편성 데이터 가져오기
      let updateData = {
        gradeAll: lotationDetail.gradeAll ? [...lotationDetail.gradeAll] : [],
        grade1: lotationDetail.grade1 ? [...lotationDetail.grade1] : [],
        grade2: lotationDetail.grade2 ? [...lotationDetail.grade2] : [],
        grade3: lotationDetail.grade3 ? [...lotationDetail.grade3] : [],
      };

      // 현재 탭에 해당하는 편성 내용을 새로운 내용으로 대체
      if (selectedTab === "전학년") {
        updateData.gradeAll = [...scheduledContents];
      } else if (selectedTab === "1학년") {
        updateData.grade1 = [...scheduledContents];
      } else if (selectedTab === "2학년") {
        updateData.grade2 = [...scheduledContents];
      } else if (selectedTab === "3학년") {
        updateData.grade3 = [...scheduledContents];
      }

      // 서버에 업데이트
      await updateEduTimetableOnServer(lotationDetail.id, updateData);

      // lotationDetail 업데이트 콜백 호출
      if (onLotationUpdate) {
        await onLotationUpdate();
      }

      onClose();
    } catch (error) {
      console.error("Failed to confirm content:", error);
    }
  };

  return (
    <>
      {/* 클릭 시 팝업 닫기 */}
      <Overlay onClick={onClose} />
      <PopupContainer>
        <Header>
          <Heading>{selectedTab} 콘텐츠 활성화 설정</Heading>
          {/* X 버튼 누르면 onClose 호출 */}
          <CloseButton onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#9CA3AF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </CloseButton>
        </Header>

        <ContentSection>
          <ContentArea>
            <ContentColumn>
              <ColumnHeader>비활성화 콘텐츠</ColumnHeader>
              <ContentList>
                {availableContents.map((content, index) => (
                  <ContentItem
                    key={content._id}
                    selected={selectedAvailable.includes(index)}
                    onClick={() => handleAvailableSelect(index)}
                  >
                    <CheckboxContainer>
                      {selectedAvailable.includes(index) ? (
                        <CheckedSvg />
                      ) : (
                        <UncheckedSvg />
                      )}
                    </CheckboxContainer>
                    <ContentTitle>{content.dataAnalysis?.title}</ContentTitle>
                  </ContentItem>
                ))}
              </ContentList>
            </ContentColumn>

            <ArrowColumn>
              <ArrowButton
                onClick={moveToScheduled}
                disabled={selectedAvailable.length === 0}
              >
                <RightArrowSvg />
              </ArrowButton>
              <ArrowButton
                onClick={moveToAvailable}
                disabled={selectedScheduled.length === 0}
              >
                <LeftArrowSvg />
              </ArrowButton>
            </ArrowColumn>

            <ContentColumn>
              <ColumnHeader>활성화 콘텐츠</ColumnHeader>
              <ContentList>
                {scheduledContents.map((content, index) => (
                  <ContentItem
                    key={content._id}
                    selected={selectedScheduled.includes(index)}
                    onClick={() => handleScheduledSelect(index)}
                  >
                    <CheckboxContainer>
                      {selectedScheduled.includes(index) ? (
                        <CheckedSvg />
                      ) : (
                        <UncheckedSvg />
                      )}
                    </CheckboxContainer>
                    <ContentTitle>{content.dataAnalysis?.title}</ContentTitle>
                  </ContentItem>
                ))}
              </ContentList>
            </ContentColumn>
          </ContentArea>
        </ContentSection>

        <Footer>
          <CancelButton
            Large
            Gray
            Fill
            onClick={onClose}
            style={{ minWidth: "90px", height: "40px" }}
          >
            <Sub2 color="gray700">취소</Sub2>
          </CancelButton>
          <Button
            Large
            Primary
            Fill
            onClick={handleConfirm}
            style={{ minWidth: "90px", height: "40px" }}
          >
            <Sub2 color="white">저장</Sub2>
          </Button>
        </Footer>
      </PopupContainer>
    </>
  );
}

const PopupContainer = styled.div`
  width: 720px;
  max-width: 90vw;
  max-height: 90vh;
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 40px 40px 24px 40px;
  background: white;
`;

const Heading = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: ${palette.gray900};
  margin: 0;
  line-height: 1.2;
  text-align: left;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -4px;

  &:hover {
    background: ${palette.gray100};
  }
`;

// 체크박스 SVG들
const UncheckedSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="18"
      height="18"
      rx="3"
      fill="transparent"
      stroke="rgba(179,183,186,0.5)"
      strokeWidth="1"
    />
  </svg>
);

const CheckedSvg = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="1" width="18" height="18" rx="3" fill="#256EF4" />
    <path
      d="M8.5 12.5L6 10L5.3 10.7L8.5 13.9L14.7 7.7L14 7L8.5 12.5Z"
      fill="white"
    />
  </svg>
);

// 화살표 SVG들
const RightArrowSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 4L10 8L6 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LeftArrowSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4L6 8L10 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 새로운 UI 스타일 컴포넌트들
const ContentSection = styled.div`
  padding: 24px 40px 40px 40px;
  flex: 1;
  overflow-y: auto;
`;

const ContentArea = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
`;

const ContentColumn = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ColumnHeader = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #323232;
  margin: 0;
  padding: 12px 16px;
  background: #f8f9fa;
  border-radius: 8px;
  text-align: center;
`;

const ContentList = styled.div`
  border: 1px solid #e0e4eb;
  border-radius: 8px;
  min-height: 300px;
  max-height: 300px;
  overflow-y: auto;
  background: white;
`;

const ContentItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  background: ${(props) => (props.selected ? "#ECF2FE" : "white")};

  &:hover {
    background: #f8f9fa;
  }

  &:last-child {
    border-bottom: none;
  }
`;

const CheckboxContainer = styled.div`
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ContentTitle = styled.span`
  font-size: 16px;
  color: #323232;
  user-select: none;
  text-align: left;
  word-wrap: break-word;
  line-height: 1.4;
`;

const ArrowColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
  padding-top: 60px;
`;

const ArrowButton = styled.button`
  width: 40px;
  height: 40px;
  border: 1px solid #e0e4eb;
  border-radius: 8px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: ${(props) => (props.disabled ? "#ccc" : "#666")};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: #f8f9fa;
    border-color: #256ef4;
    color: #256ef4;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const Footer = styled.div`
  display: flex;
  gap: 16px;
  padding: 24px 40px;
  background: white;
  justify-content: center;
`;

const CancelButton = styled(Button)`
  &:hover {
    background: ${palette.gray200} !important;
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;
